import { differenceInMinutes } from 'date-fns';

import { User } from 'entities';

import { loadScript } from './loadScript';
import { trackingConfig } from './config';
import { env } from 'config/env';

const MARK = '1';
const MIN_TOLERANCE = 5;

function toControlKey(userId: string) {
  return `${env.appId}_rg:${userId}`;
}

function shouldFireRegistration(user: User, queryParams: Record<string, string>) {
  const marked = localStorage.getItem(toControlKey(user.id)) === MARK;

  const registeredAt = new Date(user.joinDate);
  const inTime = Math.abs(differenceInMinutes(registeredAt, new Date())) < MIN_TOLERANCE;

  const redirectParamOk = queryParams.r0 === MARK;

  return !marked && inTime && redirectParamOk;
}

function markRegistrationFired(id: string) {
  localStorage.setItem(toControlKey(id), MARK);
}

export function trackRegistration(user: User, queryParams: Record<string, string>, defer = true) {
  if (!shouldFireRegistration(user, queryParams)) return;

  if (!window.dataLayer && defer)
    return setTimeout(() => trackRegistration(user, queryParams, false), 5_000);

  // gtag
  window.dataLayer?.push({ event: 'registration/complete' });

  // 2) Taboola lead
  window._tfa?.push({ notify: 'event', name: 'lead', id: trackingConfig.tabolaId });

  // 3) Twitter conversion
  loadScript('//platform.twitter.com/oct.js').then(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).twttr?.conversion?.trackPid(trackingConfig.registration.twitterTrackPid, {
      tw_sale_amount: 0,
      tw_order_quantity: 0,
    });
  });

  // 4) Facebook CompleteRegistration
  // Advanced matching values were empty on PHP; we can keep them blank
  // to preserve parity, but we WILL pass a stable eventID (panelistId)
  window.fbq?.('track', 'CompleteRegistration', {}, { eventID: user.id });

  // 5) Google Ads conversions (5 IDs)
  for (const id of trackingConfig.registration.googleSendTo) {
    window.gtag?.('event', 'conversion', { send_to: id });
  }

  markRegistrationFired(user.id);
}
